<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div
        class="vx-row mb-6"
        v-for="item in objUpdate.jsonFacilitador.camposObrigatorios"
        :key="item.id"
      >
        <div class="vx-col w-full">
          <span>{{ item }}</span>
          <vs-input
            type="text"
            size="large"
            class="w-full"
            :name="item"
            :id="item"
            v-model="objUpdate.parametros[item]"
            v-validate="{ required: true }"
            :state="validateState(`${item}`)"
            :danger="validateClass(`${item}`)"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            :edit="objUpdate.id_EmpresaFornecedor == null ? false : true"
            variant="success"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import BotaoSubmit from '../../components/BotaoSubmit';
import notify from '../../utils/notify';
import integrationApiService from "../../services/integration.api";

export default {
  props: {
    objUpdate: {
      type: Object,
    },
  },
  watch: {
    objUpdate(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      tiposBeneficios: [],
      formCadastro: { dados: {} },
    };
  },
  methods: {
    preencheForm() {},
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    async onSubmit() {
      this.$vs.loading();

      const payload = {
        id_EmpresaFornecedor: this.objUpdate.id_EmpresaFornecedor,
        id_fornecedor: this.objUpdate.id_fornecedor,
        nomeFornecedor: this.objUpdate.nomeFornecedor,
        jsonFacilitador: this.objUpdate.jsonFacilitador,
        parametros: this.objUpdate.parametros,
      };

      try {
        await integrationApiService.saveIntegrationParameters(payload);
        notify.notifySuccess(this.$vs, 'Operação Realizada com sucesso');
      } catch (error) {
        notify.notifyFail(this.$vs, "Erro ao salvar os parâmetros da integração");
      } finally {
        this.$vs.loading.close();
      }
    },

    resetForm() {
      this.formCadastro = {
        dados: {},
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    this.preencheForm();
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
